import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationES from './locales/es/translation.json';
import translationFR from './locales/fr/translation.json';

const resources = {
  fr: {
    translation: translationFR,
  },
  es: {
    translation: translationES,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'es'],
    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      lookupLocalStorage: 'valwin-language',
      lookupCookie: 'valwin-language',
      caches: ['localStorage', 'cookie'],
    },
    defaultNS: 'translation',
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false,
    },

    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (lng, ns, key) => {
      if (import.meta.env.DEV) {
        console.warn(`Missing translation key: ${key} for language: ${lng}`);
      }
    },

    returnObjects: true,

    react: {
      useSuspense: false,
      bindI18n: 'languageChanged',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em', 'span'],
    },
  });

export default i18n;
